import type { FormattedMessages } from '@alltrails/shared/types/FormattedMessages';
import GIVING_BACK_STRINGS from './givingBack.strings';

type GiveOrganization = {
  name: string;
  desc: string;
  iconSrc: string;
};

function getOrganizations(giveMessages: FormattedMessages<typeof GIVING_BACK_STRINGS>): GiveOrganization[] {
  const {
    CAMPING_TO_CONNECT,
    CAMPING_TO_CONNECT_DESC,
    CONSERVATION_ALLIANCE,
    CONSERVATION_ALLIANCE_DESC,
    FIRST_DESCENTS,
    FIRST_DESCENTS_DESC,
    LEAVE_NO_TRACE,
    LEAVE_NO_TRACE_DESC,
    ONE_TREE_PLANTED,
    ONE_TREE_PLANTED_DESC,
    SEMPERVIRENS,
    SEMPERVIRENS_DESC
  } = giveMessages;

  return [
    {
      name: CAMPING_TO_CONNECT,
      desc: CAMPING_TO_CONNECT_DESC,
      iconSrc: require('../../../../assets/images/about/logos/camping-to-connect-logo.svg')
    },
    {
      name: CONSERVATION_ALLIANCE,
      desc: CONSERVATION_ALLIANCE_DESC,
      iconSrc: require('../../../../assets/images/about/logos/the-conservation-alliance-logo.svg')
    },
    {
      name: FIRST_DESCENTS,
      desc: FIRST_DESCENTS_DESC,
      iconSrc: require('../../../../assets/images/about/logos/first-descents-logo.svg')
    },
    {
      name: LEAVE_NO_TRACE,
      desc: LEAVE_NO_TRACE_DESC,
      iconSrc: require('../../../../assets/images/about/logos/leave-no-trace-logo.svg')
    },
    {
      name: ONE_TREE_PLANTED,
      desc: ONE_TREE_PLANTED_DESC,
      iconSrc: require('../../../../assets/images/about/logos/one-tree-planted-logo.svg')
    },
    {
      name: SEMPERVIRENS,
      desc: SEMPERVIRENS_DESC,
      iconSrc: require('../../../../assets/images/about/logos/sempervirens-fund-logo.svg')
    }
  ];
}

export type { GiveOrganization };
export { getOrganizations };
